import { render } from "./NoData.vue?vue&type=template&id=1f79f31e&scoped=true"
import script from "./NoData.vue?vue&type=script&lang=js"
export * from "./NoData.vue?vue&type=script&lang=js"

import "./NoData.vue?vue&type=style&index=0&id=1f79f31e&scoped=true&lang=scss"

import exportComponent from "/data/jenkins/workspace/talk-community-h5-prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f79f31e"]])

export default __exports__